//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    option: {
      type: Object,
      required: true,
    }
  },
  computed: {
    isGroup () {
      return this.option.type === 'group'
    }
  }
}
